export enum ApiPaths {
  analyticsDashboardUrl = '/analytics/generate-dashboard-url',
  customerContractDashboardUrl = '/analytics/generate-customer-contract-dashboard-url'
}
